import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Construction = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="construction"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.67466 8.9454C7.20433 10.2043 5.25668 12.7222 4.52033 15.1687L4.35405 15.6913H3V18.6605H4.47258H6.56299H7.44174H18.8908H19.7459H23V18.5179V15.6913H21.6699L21.5037 15.1687C20.7673 12.7222 18.8195 10.2281 16.3492 8.96915V14.5512V15.335C16.3492 15.3825 16.3492 15.4063 16.3492 15.43C16.3255 15.6913 16.2779 15.9288 16.1592 16.1664C15.8503 16.7602 15.2328 17.1878 14.5202 17.1878H14.1402H11.5273C10.8621 17.1878 10.2683 16.8315 9.95958 16.3089C9.81706 16.0951 9.7458 15.8576 9.6983 15.5963C9.67454 15.5013 9.67454 15.43 9.67454 15.335V14.6699L9.67466 8.9454ZM11.5274 16.4039H14.4966C14.9241 16.4039 15.2804 16.1664 15.4705 15.8101C15.5655 15.6438 15.6129 15.4775 15.6129 15.2875V15.0737V14.1949V8.5891V7.78149V7.4727C15.6129 7.28267 15.5655 7.1164 15.5178 6.95013C15.3041 6.4038 14.7579 6 14.1402 6H11.5273C10.9572 6 10.4822 6.42756 10.4346 6.97388C10.4346 7.02139 10.4109 7.06889 10.4109 7.1164V7.78149V8.5891V14.2899V15.1925V15.2875C10.4109 15.525 10.4823 15.7388 10.601 15.9288C10.8148 16.2139 11.1474 16.4039 11.5274 16.4039Z" fill="#009BB3"/>
    </svg>
  );
};
/* eslint-enable max-len */

Construction.defaultProps = {
  className: null,
};

Construction.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Construction;
